import { Stack, Typography } from '@mui/material';
import { UploadFile } from '@mui/icons-material';

import { formatFileSize } from 'components/AI/AIFileNameManagement/components/AIFileNameInfo/utils';

import { truncateFileName } from 'components/AI/DeterministicFileNameManagement/utils';

import { EditableFileName } from './EditableFileName';

interface DeterministicFileInfoProps {
  fileName?: string;
  fileSize?: number;
  uploadedBy?: string;
  originalName?: string;
  onRename?: (newName: string) => Promise<void>;
  /** Forwarded to EditableFileName so the edit pencil swaps for an amber dot
   * while the parent's rename/accept mutation is in flight. */
  isMutating?: boolean;
}

export const DeterministicFileInfo = ({
  fileName,
  fileSize,
  uploadedBy,
  originalName,
  onRename,
  isMutating,
}: DeterministicFileInfoProps) => (
  <Stack sx={{ mt: 0.625 }}>
    <EditableFileName
      variant="post-accept"
      value={fileName || ''}
      onRename={(name) => onRename?.(name) ?? Promise.resolve()}
      showEdit={!!onRename}
      optimisticClose
      isMutating={isMutating}
    />
    <Typography variant="body2" color="text.disabled" sx={{ mt: 1.25 }}>
      {uploadedBy} {'\u00B7'} {formatFileSize(fileSize)}
    </Typography>
    {originalName && (
      <Typography
        variant="body2"
        color="text.secondary"
        title={originalName}
        sx={{ mt: 1.875, display: 'flex', alignItems: 'center', gap: '4px' }}
      >
        <UploadFile sx={{ fontSize: '16px', flexShrink: 0 }} />
        {truncateFileName(originalName)}
      </Typography>
    )}
  </Stack>
);
